import type {
  RequestActionCreator,
  RequestSuccessActionCreator,
  RequestFailureActionCreator,
} from "./types";

export const SERVICES_EXPORT_POST_REQUEST = "SERVICES_EXPORT_POST_REQUEST";
export const SERVICES_EXPORT_POST_REQUEST_SUCCESS =
  "SERVICES_EXPORT_POST_REQUEST_SUCCESS";
export const SERVICES_EXPORT_POST_REQUEST_FAILURE =
  "SERVICES_EXPORT_POST_REQUEST_FAILURE";
export const SERVICES_EXPORT_POST_RESET = "SERVICES_EXPORT_POST_RESET";
export const SERVICES_EXPORT_DOWNLOAD_CLICKED =
  "SERVICES_EXPORT_DOWNLOAD_CLICKED";
export const DOWNLOAD_CLICKED = SERVICES_EXPORT_DOWNLOAD_CLICKED;

export const SOCKET_EVENT_OBJECTS_SERVICES_ARCHIVE_GENERATION =
  "SOCKET_EVENT_OBJECTS_SERVICES_ARCHIVE_GENERATION";
export const SOCKET_EVENT_OBJECTS_SERVICES_ARCHIVE_GENERATION_ERROR =
  "SOCKET_EVENT_OBJECTS_SERVICES_ARCHIVE_GENERATION_ERROR";

export const EXPORT_GENERATION_FAILED = "EXPORT_GENERATION_FAILED";

export const request: RequestActionCreator = (
  payload,
  tenantId,
  resolve,
  reject
) => ({
  type: SERVICES_EXPORT_POST_REQUEST,
  payload,
  tenantId,
  resolve,
  reject,
});

export const requestSuccess: RequestSuccessActionCreator = (
  tenantId,
  data
) => ({
  type: SERVICES_EXPORT_POST_REQUEST_SUCCESS,
  data,
  tenantId,
});

export const requestFailure: RequestFailureActionCreator = (
  tenantId,
  error
) => ({
  type: SERVICES_EXPORT_POST_REQUEST_FAILURE,
  error,
  tenantId,
});

export const downloadClicked = () => ({
  type: SERVICES_EXPORT_DOWNLOAD_CLICKED,
});

export const reset = () => ({
  type: SERVICES_EXPORT_POST_RESET,
});
